module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/3-b58e9eda51491e8452c82fae996b079a.png";